module.exports = __webpack_public_path__ + "img/AFCFTA IMG1.275c16b1.jpg";